<template>
  <div class="sd_fansNumber_pendant">
    <img v-if="url" :src="url" :style="{ width: `${width}px`, height: `${width}px` }" />
  </div>
</template>
<script>
import { getFansPendantUrl } from '../utils/lib';
import { mapState } from 'vuex'

export default {
  props: {
    width: {
      type: Number,
      default: 14,
    },
    userId: {
      type: [Number, String],
      required: true,
    }
  },
  computed: {
    url() {
      const info = this.userInfoList.find((item) => +item.userId === +this.userId);
      const url = getFansPendantUrl(info?.followerNum);
      return url
    },
    ...mapState(['userInfoList'])
  }
}
</script>
<style lang="less" scoped>
.sd_fansNumber_pendant {
  position: absolute;
  bottom: 0;
  right: -3px;
}
</style>